<template>
  <NewAccountErrorTemplate :title="title" :subtitle="subtitle" />
</template>

<script>
import NewAccountErrorTemplate from "@/views/profile/components/NewAccountErrorTemplate";

const TITLE = "The closing date for this role has passed";
const SUBTITLE =
  "You are no longer able to apply for this role as the closing date has passed";

export default {
  name: "InvalidBooking",
  components: {
    NewAccountErrorTemplate
  },
  data() {
    return {
      title: TITLE,
      subtitle: SUBTITLE
    };
  }
};
</script>

<style lang="scss"></style>
